module.exports = __webpack_public_path__ + "static/TMN_loader.ea2a34e3.gif";